import { z } from 'zod'

export default z.object({
  __typename: z.literal('StorageRule').default('StorageRule'),
  id: z.number(),
})
